import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=46e111e4"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports